import { render, staticRenderFns } from "./AttributesSubsection.vue?vue&type=template&id=da8514f2&scoped=true"
import script from "./AttributesSubsection.vue?vue&type=script&lang=ts"
export * from "./AttributesSubsection.vue?vue&type=script&lang=ts"
import style0 from "./AttributesSubsection.vue?vue&type=style&index=0&id=da8514f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8514f2",
  null
  
)

export default component.exports